const ITEMS = [
  {
    n: "01",
    title: "Liquidação na hora",
    desc: "Processamento em tempo real, sem espera, sem letras miúdas. O dinheiro chega quando deveria chegar.",
  },
  {
    n: "02",
    title: "Segurança que não pede licença",
    desc: "Criptografia forte, monitoramento 24/7 e compliance ponta-a-ponta. A gente cuida disso pra você não precisar.",
  },
  {
    n: "03",
    title: "Integração que não morde",
    desc: "APIs claras, SDKs prontos e documentação que respeita seu tempo. Integra em horas, não semanas.",
  },
];

export default function Features() {
  return (
    <section id="features" className="relative py-24 md:py-32 border-y-2 border-ink bg-cream-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <span className="chip mb-4">Por que OK!pag</span>
          <h2 className="font-display font-extrabold text-ink text-4xl md:text-5xl leading-[1.05] tracking-tightest">
            Tecnologia robusta.
            <br />
            <span className="text-brand-600">Simplicidade visível.</span>
          </h2>
          <p className="mt-5 text-lg text-ink-muted">
            Cada decisão de produto começa com uma pergunta: isso facilita a vida de quem usa?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {ITEMS.map((it) => (
            <article key={it.n} className="card-brutal p-7 flex flex-col">
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-display font-extrabold text-5xl text-brand-500 leading-none">
                  {it.n}
                </span>
                <span
                  aria-hidden
                  className="h-3 w-3 rounded-full bg-ink"
                  title="●"
                />
              </div>
              <h3 className="font-display font-bold text-xl text-ink mb-2 tracking-tight">
                {it.title}
              </h3>
              <p className="text-ink-muted leading-relaxed">{it.desc}</p>
            </article>
          ))}
        </div>

        {/* Faixa de chamada secundária */}
        <div className="mt-20 bg-ink text-cream-50 border-2 border-ink rounded-2xl px-8 py-10 md:px-12 md:py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 shadow-brutal-brand">
          <div>
            <h3 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight">
              Pronto pra começar?
            </h3>
            <p className="text-cream-200 mt-2 max-w-lg">
              Conversa rápida, integração simples. A gente te mostra como em uma call.
            </p>
          </div>
          <a
            href="#contato"
            className="inline-flex items-center gap-2 bg-brand-500 text-ink font-display font-bold border-2 border-brand-500 rounded-xl px-7 py-3 hover:bg-brand-400 hover:border-brand-400 transition-colors whitespace-nowrap"
          >
            Quero conversar
            <span className="text-xl leading-none">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
